// App.js
import React from 'react';
import '../App.css';
import Hero from '../components/Hero';
import Features from '../components/Features';
import ContactForm from '../components/ContactForm';


const Home = () => {
  return (
    <div className="App">
      <Hero />
      <Features />
      <ContactForm />
    </div>
  );
};

export default Home;
